import { useMutation } from '@apollo/client';
import { saveAs } from 'file-saver';
import { EXPORT_EXCEL_GRAPHIC_STAND } from 'graphql/mutation/graphic-stand-gql';

const useMutationGraphicStandExportExcel = () => {
    const [exportExcel, { loading }] = useMutation(EXPORT_EXCEL_GRAPHIC_STAND);

    const handleExportExcel = async (id) => {
        try {
            const { data } = await exportExcel({
                variables: { id }
            });

            if (data?.graphicListStandExportExel?.file) {
                const fileUrl = data.graphicListStandExportExel.file;

                try {
                    const response = await fetch(fileUrl);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const blob = await response.blob();
                    const fileName = fileUrl.split('/').pop() || `graphic-stand-export-${id}.xlsx`;

                    saveAs(blob, fileName);
                    return { success: true };
                } catch (downloadError) {
                    console.error('Download error:', downloadError);
                    return { success: false, error: 'Error downloading the file:' + downloadError.message };
                }
            }

            return { success: false, error: 'No file data in server response' };
        } catch (error) {
            console.error('Export error:', error);
            return { success: false, error: error.message };
        }
    };

    return {
        _setGraphicStandExportExcel: handleExportExcel,
        loadingMutationGraphicStandExportExcel: loading
    };
};

export default useMutationGraphicStandExportExcel;